<div class=" main-container ">
    <div class="d-flex inner-container flex-column p-4 justify-content-between">
        <div class="gap-1 d-flex flex-wrap align-content-center">
            <div class="d-flex company-name align-items-center">
                <div class="logo bg-white align-items-center justify-content-center d-flex rounded">
                    <img [src]="company?.logo" onerror="this.style.display = 'none'" />
                </div>
                <div>
                    <div style="margin-bottom:-.5rem" class="text-dark">{{company?.name}}</div>
                    <small class="text-sm">CBT Portal</small>
                </div>

            </div>
            <div class="ml-auto text-dark">{{currentTime?.date}} <span class="time">&nbsp; {{currentTime?.time}}</span>
            </div>
        </div>
        <div *ngIf="examDetails" class="rounded cFade tile mx-auto bg-white p-3 d-flex flex-column">
            <div class="d-flex align-items-center gap-1">
                <div>
                    Welcome, <span class="student-name">{{student?.name?.toLowerCase()}}</span>
                </div>
                <div class="avatar-wrapper ml-auto">
                    <img [src]="student?.passport" onerror="this.src = 'assets/images/man.png'" class="w-100 h-100"
                        alt="Passport">
                </div>
            </div>
            <div class="flex gap-4 [flex-direction:column-reverse] md:flex-row">
                <div class="w-full">
                    <div class="text-sm">
                        Please read carefully the details below before starting your CBT.
                    </div>
                    <table class="table mt-4">
                        <tr>
                            <td>Full Name</td>
                            <td style="text-transform: capitalize;">{{student?.name?.toLowerCase()}}</td>
                        </tr>
                        <tr>
                            <td>{{p_system == 'tert' ? 'Matric Number' : 'ID'}}</td>
                            <td>{{p_system == 'tert' ? student?.matric_no : student?.student_id}}</td>
                        </tr>
                        <tr>
                            <td>Title</td>
                            <td>{{examDetails.exam_title}}</td>
                        </tr>
                        <tr>
                            <td>Description</td>
                            <td>{{examDetails.description}}</td>
                        </tr>
                        <tr>
                            <td>Instruction</td>
                            <td>
                                {{examDetails.instruction}}<br />
                                <small *ngIf="examDetails.camera_sound_check == 1 && examDetails.screen_tab_check == 1">
                                    This exam uses the following AI invigilator which also keep offences:<br />
                                    <span>1. Navigating to another tab: You are advise not to navigate away from the
                                        test screen to another tab</span><br />
                                    <span>2. Camera Check: You are advise not to move your face away from the test
                                        screen and multiple faces are not permitted to be seen on the test screen</span>
                                </small>
                                <small *ngIf="examDetails.camera_sound_check == 0 && examDetails.screen_tab_check == 1">
                                    This exam uses an AI invigilator which also keep offences:<br />
                                    Navigating to another tab: You are advise not to navigate away from the test screen
                                    to another tab
                                </small>
                                <small *ngIf="examDetails.camera_sound_check == 1 && examDetails.screen_tab_check == 0">
                                    This exam uses an AI invigilator which also keep offences:
                                    <br />
                                    Camera Check: You are advise not to move your face away from the test screen and
                                    multiple faces are not permitted to be seen on the test screen
                                </small>
                            </td>
                        </tr>
                        <tr>
                            <td>Duration</td>
                            <td>{{duration + ' minutes'}}</td>
                        </tr>
                        <tr>
                            <td>Time Left</td>
                            <td>{{timeLeft + ' minutes'}}</td>
                        </tr>
                        <tr>
                            <td>Exam Mode</td>
                            <td>{{examDetails.exam_mode == 0 ? "Onsite (Physical)" : "Online (Virtual)"}}</td>
                        </tr>
                    </table>
                </div>
                <div class="w-80" *ngIf="this.exam_mode == 1 && this.camera_check == 1 && !offenceFull">
                    <p class="text-muted text-xs">Ensure you stay in a well lighted place to be able to take the test
                    </p>

                    <video #video autoplay muted class="rounded-lg" width="200" height="200"></video>
                    <span class="text-neutral-600 font-normal">{{cameraMsg}}</span>
                </div>

            </div>

            <div class="flex rounded-md gap-2 bg-red-50 items-center border-[1px] border-red-300 p-2 my-2"
                *ngIf="offenceFull">
                <p class="text-sm text-red-500">Your offence meter is full and you are not permitted to write this exam
                    anymore. Kindly reach out to your exam coordinator.</p>
            </div>

            <div class="nb text-sm"><b>NB:</b> Please complete the test in a quiet and distraction-free environment.
                Follow the instructions carefully.
            </div>
            <div class *ngIf="examDetails.exam_mode == 0 && examDetails.invigilator_code == true && !offenceFull">
                <mat-form-field appearance="outline">
                    <mat-label>Invigilator's code</mat-label>
                    <input type="text" matInput placeholder="Invigilator should enter the invigilator's code here!"
                        name="inv_code" required="" [(ngModel)]="inv_code" (keyup)="checkInvigilatorCode()"
                        maxlength="5" />
                    <mat-hint
                        [class]="invCodeMsg == 'Verified! Kindly proceed' ? 'text-green-600' : 'text-rose-500'">{{invCodeMsg}}</mat-hint>
                </mat-form-field>
            </div>
            <!-- <div class="nb text-sm"><b>NB:</b> Please ensure you're in a quiet area with no distractions and that only
                you are in front of the computer. During the test, an 'offense meter' will be displayed at the top of
                the page. If it reaches 100%, your exam will be automatically submitted. Please follow the instructions
                and complete the test carefully.
            </div> -->

            <div class="d-flex mt-4 justify-content-between">
                <button mat-button type="button" (click)="goBack()">Go Back</button>
                <button mat-raised-button color="primary" type="button" (click)="startExam()"
                    *ngIf="verified">Proceed</button>
            </div>
        </div>

        <div class="gap-1 d-flex justify-content-between align-items-center">
            <span class="text-sm text-uppercase">
                {{company?.subdomain+' CBT'}} | {{currentTime.year}}
            </span>
            <div class="powered-by">
                Powered By
                <img src=" assets/images/edozzier-log.png" class="h-4 d-inline rm-drag" />
            </div>
        </div>
    </div>
</div>